(()=>{

  let sparkles = 50;
  let x = 0, ox = 0;
  let y = 0, oy = 0;
  let swide = 800, shigh = 600;
  let sleft = 0, sdown = 0;

  let tiny  = [], star  = [];
  let starv = [], starx = [], stary = [];
  let tinyx = [], tinyy = [], tinyv = [];

  // Embedded image 
  let SPARKLE_IMG = 'data:image/png;base64,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';
  let SPARKLE_W = 32;
  let SPARKLE_H = 22;

  // --- Trailing dot trail ---
  let n = 10;
  let dots = [];

  function initDots() {
    let container = document.createElement('div');
    container.style.cssText = 'position:fixed;top:0;left:0;pointer-events:none;z-index:998;';
    document.body.appendChild(container);

    for (let i = 0; i < n; i++) {
      let dot = document.createElement('div');
      let size = i / 2;
      dot.style.cssText = [
        'position:absolute',
        'top:0px',
        'left:0px',
        'width:'  + size + 'px',
        'height:' + size + 'px',
        'pointer-events:none'
      ].join(';');
      container.appendChild(dot);
      dots[i] = dot;
    }
  }

  function animateDots() {
    for (let i = 0; i < n; i++) {
      if (i < n - 1) {
        dots[i].style.top  = dots[i + 1].style.top;
        dots[i].style.left = dots[i + 1].style.left;
      } else {
        dots[i].style.top  = y + 'px';
        dots[i].style.left = x + 'px';
      }
    }
    setTimeout(animateDots, 10);
  }

  // --- PNG image instead of cross divs ---
  function initSparkles() {
    for (let i = 0; i < sparkles; i++) {
      // tiny dot remnant (kept as before)
      let tinyDiv = createDiv(3, 3);
      tinyDiv.style.visibility = 'hidden';
      tinyDiv.style.zIndex = '999';
      document.body.appendChild(tiny[i] = tinyDiv);
      starv[i] = 0;
      tinyv[i] = 0;

      // PNG image element instead of cross divs
      let img = document.createElement('img');
      img.src = SPARKLE_IMG;
      img.style.position      = 'absolute';
      img.style.width         = SPARKLE_W + 'px';
      img.style.height        = SPARKLE_H + 'px';
      img.style.visibility    = 'hidden';
      img.style.zIndex        = '999';
      img.style.pointerEvents = 'none';
      // offset so the image centre sits on the cursor
      img.style.marginLeft    = (-SPARKLE_W / 2) + 'px';
      img.style.marginTop     = (-SPARKLE_H / 2) + 'px';
      document.body.appendChild(star[i] = img);
    }
  }

  function sparkle() {
    if (Math.abs(x - ox) > 1 || Math.abs(y - oy) > 1) {
      ox = x;
      oy = y;
      for (let c = 0; c < sparkles; c++) {
        if (!starv[c]) {
          star[c].style.left = (starx[c] = x) + 'px';
          star[c].style.top  = (stary[c] = y + 1) + 'px';
          star[c].style.visibility = 'visible';
          // fade in at full size
          star[c].style.opacity = '1';
          star[c].style.width  = SPARKLE_W + 'px';
          star[c].style.height = SPARKLE_H + 'px';
          starv[c] = 50;
          break;
        }
      }
    }
    for (let c = 0; c < sparkles; c++) {
      if (starv[c]) update_star(c);
      if (tinyv[c]) update_tiny(c);
    }
    setTimeout(sparkle, 40);
  }

  function update_star(i) {
    starv[i]--;
    // shrink and fade as life drains
    let life = starv[i] / 50;
    star[i].style.opacity = life;
    star[i].style.width   = Math.round(SPARKLE_W * life) + 'px';
    star[i].style.height  = Math.round(SPARKLE_H * life) + 'px';

    if (starv[i]) {
      stary[i] += 1 + Math.random() * 3;
      starx[i] += (i % 5 - 2) / 5;
      if (stary[i] < shigh + sdown) {
        star[i].style.top  = stary[i] + 'px';
        star[i].style.left = starx[i] + 'px';
      } else {
        star[i].style.visibility = 'hidden';
        starv[i] = 0;
      }
    } else {
      // hand off to tiny remnant dot
      tinyv[i] = 50;
      tiny[i].style.top             = (tinyy[i] = stary[i]) + 'px';
      tiny[i].style.left            = (tinyx[i] = starx[i]) + 'px';
      tiny[i].style.width           = '2px';
      tiny[i].style.height          = '2px';
      tiny[i].style.backgroundColor = '#ff69b4'; // pink to match lips
      star[i].style.visibility      = 'hidden';
      tiny[i].style.visibility      = 'visible';
    }
  }

  function update_tiny(i) {
    if (--tinyv[i] === 25) {
      tiny[i].style.width  = '1px';
      tiny[i].style.height = '1px';
    }
    if (tinyv[i]) {
      tinyy[i] += 1 + Math.random() * 3;
      tinyx[i] += (i % 5 - 2) / 5;
      if (tinyy[i] < shigh + sdown) {
        tiny[i].style.top  = tinyy[i] + 'px';
        tiny[i].style.left = tinyx[i] + 'px';
      } else {
        tiny[i].style.visibility = 'hidden';
        tinyv[i] = 0;
      }
    } else {
      tiny[i].style.visibility = 'hidden';
    }
  }

  // --- Mouse ---
  document.addEventListener('mousemove', function(e) {
    y = e.pageY;
    x = e.pageX;
  });

  // --- Scroll ---
  window.addEventListener('scroll', set_scroll);
  function set_scroll() {
    if (typeof self.pageYOffset === 'number') {
      sdown = self.pageYOffset;
      sleft = self.pageXOffset;
    } else if (document.body && (document.body.scrollTop || document.body.scrollLeft)) {
      sdown = document.body.scrollTop;
      sleft = document.body.scrollLeft;
    } else if (document.documentElement && (document.documentElement.scrollTop || document.documentElement.scrollLeft)) {
      sdown = document.documentElement.scrollTop;
      sleft = document.documentElement.scrollLeft;
    } else {
      sdown = 0;
      sleft = 0;
    }
  }

  // --- Resize ---
  window.addEventListener('resize', set_width);
  function set_width() {
    let sw = window.innerWidth  || document.documentElement.clientWidth  || document.body.clientWidth  || 800;
    let sh = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 600;
    swide = sw;
    shigh = sh;
  }

  // --- Helpers ---
  function createDiv(height, width) {
    let div = document.createElement('div');
    div.style.position      = 'absolute';
    div.style.height        = height + 'px';
    div.style.width         = width  + 'px';
    div.style.overflow      = 'hidden';
    div.style.pointerEvents = 'none';
    return div;
  }

  // --- init ---
  document.addEventListener('DOMContentLoaded', function() {
    initDots();
    animateDots();
    initSparkles();
    set_width();
    sparkle();
  });
})();